import env from '@/config/env';

const log = {
  debug: (m: string) => {
    if (!env.isProduction) {
      // eslint-disable-next-line no-console
      console.log(m);
    }
  },
};

export default log;
